import React from 'react';
import { Typography, theme } from 'antd';

import { useSelector } from '../../../hooks/usePrerenderUser';

function Greeting() {
  const { token } = theme.useToken();
  const firstName = useSelector((state) => state.prerenderUser.firstName);

  const greetingMessage = React.useMemo(() => {
    const hour = new Date().getHours();
    let greeting = 'Good Evening';

    if (hour >= 4 && hour < 12) {
      greeting = 'Good Morning';
    } else if (hour >= 12 && hour < 17) {
      greeting = 'Good Afternoon';
    }

    return greeting;
  }, []);

  const getUserName = React.useMemo(() => {
    if (firstName) return `, ${firstName}`;
    return '!';
  }, [firstName]);

  return (
    <div style={{ marginBottom: token.margin }}>
      <Typography.Title level={2} style={{ marginBottom: token.marginXXS }}>
        {greetingMessage}
        {getUserName} 🙂
      </Typography.Title>
      <Typography.Text style={{ color: token.colorTextQuaternary }}>
        Track, manage and forecast your Prerender activity and usage.
      </Typography.Text>
    </div>
  );
}

export default Greeting;
